var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.524,
    height: 90.471,
    viewBox: "0 0 90.524 90.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M15.727,78.789A44.7,44.7,0,1,1,84.641,64.813l4.69,18.745a4.246,4.246,0,0,1-5.28,5.1l-17.42-4.908a44.733,44.733,0,0,1-50.905-4.958ZM21.06,17.214A36.252,36.252,0,0,0,63.727,75.569a4.244,4.244,0,0,1,3.474-.561l12.088,3.474L76.012,65.374a4.266,4.266,0,0,1,.372-3.16,35.735,35.735,0,0,0,3.364-8.433A36.411,36.411,0,0,0,70.281,19.1v.014a36.252,36.252,0,0,0-49.22-1.9Z",
    transform: "translate(0.545 0.5)",
    fill: "rgba(93,169,221,0.19)",
    stroke: "#5da9dd",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaComment);
export default __webpack_public_path__ + "static/media/instaComment.f7002ed67577c861e2de3ba4086a5de8.svg";
export { ForwardRef as ReactComponent };